import { useQuery, useMutation, useQueryClient, useInfiniteQuery} from '@tanstack/react-query';
import axiosClient from '../api/interceptor-v2';


//list file fetch *****

export const fetchActivityLogsData = async ({ queryKey, pageParam = 1 }) => {

  try {

      const [key, rowCount,dateFrom,dateTo, searchTerm] = queryKey;

        console.log('fetchData cc inside---', {queryKey, pageParam});

        // if (!region) return;

        console.log('fetchData cc inside--- 22', {queryKey, pageParam});
        // console.log('AMILA SEARCH', key, rowCount,dateFrom,dateTo, searchTerm)
        // Await the axios call to ensure you receive the response before proceeding
        const response = await axiosClient.get(`/activity_logs?limit=${15}&keyword=${searchTerm}&from=${pageParam}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
        // const response = await axiosClient.get(`/handle_app_request.php?tId=company&activity_logs?recordsCount=${15}&fileType=${filter}&status=${tabState}&search=${searchTerm}&regions=${region}&sort=${sort},${sortCol}&from=${pageParam}`);
        
        let data = response.data;

        console.log('fetch response filexxx', data.result, {
          ...data.result,
          nextCursor: data.result.isLastPage ? null : pageParam + 1,
        }, 'xxx' )
        //return data.result.content;
        return{
          ...data.result.content,
          nextCursor: data.result.content.isLastPage ? null : pageParam + 1,
        } 

  } catch (err) {

        console.error('fetchData error:', err.message);
        throw err;

  }
  
};

//has document

const fetchHasDocument = async () => {

  try {

    const response = await axiosClient.get(`/list_files?documentCheck=1`)
    let data = response.data.result;
    return data;


  }
  catch (err) {

    console.error('fetchData error:', err.message);
    throw err;

  }

};


export function useListInfinityActivityLogs({rowCount, dateFrom,dateTo,searchTerm}) {
  console.log('useListInfinityActivityLogs', rowCount)
  
  return useInfiniteQuery({
      queryKey: ['fetchActivityData', rowCount, dateFrom,dateTo,searchTerm],
      queryFn: fetchActivityLogsData,
      cacheTime: 24 * 60 * 60 * 1000, 
    //   refetchInterval: 5000,
      initialPageParam: 1,
      getNextPageParam: (lastPage) => lastPage?.nextCursor || null,
  });
}

export function useListActivityLogs({rowCount,dateFrom,dateTo, searchTerm}) {

    return useInfiniteQuery({
        queryKey: ['fetchActivityData', rowCount,dateFrom,dateTo, searchTerm],
        queryFn: fetchActivityLogsData,
        cacheTime: 24 *60 * 60 * 1000, 
        initialPageParam: 1,
        getNextPageParam: (lastPage) => lastPage?.nextCursor || null,
    });

}

export function useHasDocument() {
  return useQuery({
    queryKey: ['fetchHasDocument'],
    queryFn: fetchHasDocument,
    cacheTime: 60 * 60 * 1000,
  });
}


//post retry file

export const useRetryFileMutation = (
  onSuccessCallback
) => {

  const queryClient = useQueryClient()

  return useMutation({
    // The function that actually performs the POST
    mutationKey: ['retryFile'],
    mutationFn: async (data) => {
      

      // Perform the POST request
      const res = await axiosClient.post(`/reprocess_file`, data)
      return res.data
    },

    // Handle what to do after success
    onSuccess: (data) => {
      const { result, error } = data

      // refetch other queries if needed

      //queryClient.invalidateQueries(["getDataRetain"])

      // Or trigger a callback
      if (onSuccessCallback) onSuccessCallback(data.result)


    },

    // Handle errors
    onError: (error) => {
      console.error("POST Mutation Error:", error)
    },
  })

}


//file delete

export const useFileDeleteMutation = (
  onSuccessCallback

) => {
  const queryClient = useQueryClient()

  return useMutation({
    // The function that actually performs the POST
    mutationKey: ['deleteFile'],
    mutationFn: async (data) => {
      console.log('delete file data', data)
      // Perform the POST request
      const res = await axiosClient.delete(`/document`, {data:data})
      return res.data

    },

    // Handle what to do after success
    onSuccess: (data) => {
      const { result, error } = data

      // refetch other queries if needed
      queryClient.invalidateQueries(["fetchData"])

      // Or trigger a callback
      if (onSuccessCallback) onSuccessCallback(data.result)

    },

    // Handle errors
    onError: (error) => {
      console.error("POST Mutation Error:", error)
    },
  })

}


